import { render, staticRenderFns } from "./ChatWidget.vue?vue&type=template&id=77dad390&"
import script from "./ChatWidget.vue?vue&type=script&lang=ts&"
export * from "./ChatWidget.vue?vue&type=script&lang=ts&"
import style0 from "./ChatWidget.vue?vue&type=style&index=0&id=77dad390&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports